export const CLIP_LIBRETTO_CLIP_ID = "libretto_clip_id"

export const MEDIA_WAVEFORM_DATA = "media_waveform_data"

export const MEDIA_ENTITY_ID = "media_entity_id"

export const MEDIA_TRANSCRIPT_URL = "media_transcript_url"

export const MEDIA_TRANSCRIPT = "media_transcript"

export const MEDIA_DURATION = "media_duration"

export const GenerateLibrettoClipId = (): string => {
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

    const generateRandomString = (length: number): string => {
        let result = '';
        for (let i = 0; i < length; i++) {
            result += charset.charAt(Math.floor(Math.random() * charset.length));
        }
        return result;
    };

    const part1 = generateRandomString(10);
    const part2 = generateRandomString(10);

    return `${part1}-${part2}`;
}